import { render, staticRenderFns } from "./DialogMeusParcelamentos.vue?vue&type=template&id=64032f12&scoped=true"
import script from "./DialogMeusParcelamentos.vue?vue&type=script&lang=js"
export * from "./DialogMeusParcelamentos.vue?vue&type=script&lang=js"
import style0 from "./DialogMeusParcelamentos.vue?vue&type=style&index=0&id=64032f12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64032f12",
  null
  
)

export default component.exports